import * as React from 'react';

const Accommodation = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
        <path
            fill="currentColor"
            fillRule="nonzero"
            d="M19.6 7.8a.8.8 0 0 0-.311-.633l-8.8-6.8a.8.8 0 0 0-.98 0l-8.8 6.8A.8.8 0 0 0 .4 7.8v10.8a.8.8 0 0 0 .8.8h6.4A.4.4 0 0 0 8 19v-3.6a2 2 0 1 1 4 0V19c0 .22.18.4.4.4h6.4a.8.8 0 0 0 .8-.8z"
        />
    </svg>
);
export default Accommodation;
